module.exports = __webpack_public_path__ + "img/home_btn.ba8d5752.png";